import axios from 'axios'

export default {
  namespaced: true,
  state: {
    accessRights: []
  },

  mutations: {
    setAccessRights (state, accessRights) {
      state.accessRights = accessRights
    }
  },

  actions: {
    /**
     * Get access rights
     */
    async getAccessRights ({ commit }) {
      try {
        const accessRights = (await axios.get(`${process.env.VUE_APP_API_URI}/admin-console/restricted-modules`)).data
        commit('setAccessRights', accessRights)
      } catch (error) {
        console.error(`Error while getting access rights: ${error}`)
        throw error
      }
    }
  }
}
